// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"3fc6234e","578":"b206bc15"}[chunkId] + ".chunk.js";
};